import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    color: colour.grey[200]
  }
});
